import React, { useContext, useEffect } from 'react'

import { navigate } from 'gatsby'
import ButtonClose from '../../atoms/button-close/button-close'
import { Context } from '../../../context/app-context'

import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import './modalTerms.scss'
import { termsList } from './termsData'

///////////

const ModalTerms = () => {
  const { dispatch } = useContext(Context)
  const userInfo = getUserInfo()

  const handlerClose = () => {
    dispatch({ type: 'clear-modal' })
    navigate('/')
  }

  const handleDataLayer = async () => {
    pushEventData({
      event: 'Interacciones_Términos_Condiciones_RompeTabus',
      label: 'Términos y condiciones',
      action: 'view',
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  useEffect(() => {
    handleDataLayer()
  }, [])

  return (
    <div className="f-modal-terms">
      <ButtonClose
        className="f-modal-terms__close "
        onClick={handlerClose}
        title="cerrar modal y regresar al home"
      />
      <article className="f-modal-terms__container">
        <h2 className="f-modal-terms__title">Términos y condiciones</h2>
        <div className="f-modal-terms__scroller">
          <ul>
            {termsList.map((item, index) => {
              return <li key={index}>{item}</li>
            })}
          </ul>
        </div>
      </article>
    </div>
  )
}

export default ModalTerms
